import React, {useState} from "react";
import {observer} from "mobx-react-lite";

import {AutoComplete} from "primereact/autocomplete";

import appStore from "../../../../storage/AppStore";
import clubStore from "../../../../storage/ClubStore";

import Radio from "../../../../ui/Radio";

import CompanyUserForm from "./CompanyUserForm";


const normalizeChild = (item) => {
    if (!item) {
        return null;
    }

    const id =
        item.id ??
        item.company_user_id;

    if (!id) {
        return null;
    }

    return {
        ...item,

        id,

        company_user_id:
            item.company_user_id ??
            id,
    };
};


const normalizeChildren = (items) => {
    const result = [];
    const ids = new Set();

    (items || []).forEach(
        (item) => {
            const child =
                normalizeChild(item);

            if (
                !child ||
                ids.has(child.id)
            ) {
                return;
            }

            ids.add(child.id);

            result.push(child);
        }
    );

    return result;
};


const ParentForm = () => {

    const member =
        clubStore.member;


    const [
        suggestions,
        setSuggestions,
    ] = useState([]);


    const parentTypeSelected =
        Boolean(member.is_mother) !==
        Boolean(member.is_father);


    const parentTypeInvalid =
        Boolean(
            member.was_validated &&
            !parentTypeSelected
        );


    const childrenInvalid =
        Boolean(
            member.was_validated &&
            parentTypeSelected &&
            (
                !Array.isArray(
                    member.children
                ) ||
                member.children.length === 0
            )
        );


    const searchChildren = async (
        event
    ) => {

        if (
            !parentTypeSelected ||
            !member.company_id
        ) {
            setSuggestions([]);
            return;
        }


        const members =
            await clubStore
                .searchMembersForFilter({
                    title:
                        event.query,

                    role_id:
                        "MMBR",

                    company_user_id:
                        null,

                    company_id:
                        member.company_id,

                    for_parent:
                        true,

                    is_mother:
                        Boolean(
                            member.is_mother
                        ),

                    is_father:
                        Boolean(
                            member.is_father
                        ),

                    parent_id:
                        member.id || null,
                });


        setSuggestions(
            normalizeChildren(
                members
            )
        );
    };


    const setParentType = (
        type
    ) => {

        const isMother =
            type === "mother";


        member.setProperty(
            "is_mother",
            isMother
        );

        member.setProperty(
            "is_father",
            !isMother
        );


        /*
         * Do not clear selected children.
         *
         * We only change the relation side.
         */
        setSuggestions([]);
    };


    const handleChildrenChange = (
        event
    ) => {

        member.setProperty(
            "children",
            normalizeChildren(
                event.value
            )
        );
    };


    return (
        <CompanyUserForm
            title={
                member.id
                    ? appStore.tr.edit
                    : appStore.tr.add_parent
            }
        >

            {/* PARENT TYPE */}

            <div
                className="col-12"
                role="radiogroup"
                aria-label={
                    appStore.tr.parent_type ||
                    appStore.tr.parent
                }
            >

                <div className="grid">

                    <div className="col-6">

                        <Radio
                            name="parent_type"

                            checked={
                                Boolean(
                                    member.is_mother
                                )
                            }

                            label={
                                appStore.tr.mother
                            }

                            onChange={() =>
                                setParentType(
                                    "mother"
                                )
                            }
                        />

                    </div>


                    <div className="col-6">

                        <Radio
                            name="parent_type"

                            checked={
                                Boolean(
                                    member.is_father
                                )
                            }

                            label={
                                appStore.tr.father
                            }

                            onChange={() =>
                                setParentType(
                                    "father"
                                )
                            }
                        />

                    </div>

                </div>


                {parentTypeInvalid && (
                    <small className="p-error block mt-1">
                        {
                            appStore.tr.choose_mother_or_father ||
                            appStore.tr.please_check_data
                        }
                    </small>
                )}

            </div>


            {/* CHILDREN */}

            <div className="col-12">

                <label
                    htmlFor="input_parent_children"
                    className="block mb-2"
                >
                    {appStore.tr.children}
                </label>


                <AutoComplete
                    inputId="input_parent_children"

                    value={
                        member.children || []
                    }

                    suggestions={
                        suggestions
                    }

                    completeMethod={
                        searchChildren
                    }

                    field="title"

                    multiple
                    dropdown
                    forceSelection

                    disabled={
                        !parentTypeSelected
                    }

                    className={[
                        "w-full",

                        childrenInvalid &&
                            "p-invalid",
                    ]
                        .filter(Boolean)
                        .join(" ")
                    }

                    onChange={
                        handleChildrenChange
                    }
                />


                {childrenInvalid && (
                    <small className="p-error block mt-1">
                        {
                            appStore.tr.no_children_found ||
                            appStore.tr.please_check_data
                        }
                    </small>
                )}

            </div>

        </CompanyUserForm>
    );
};


export default observer(
    ParentForm
);